// Entry point for the build script in your package.json
import { Application } from "@hotwired/stimulus"
import "@hotwired/turbo-rails"

// ViewComponent controllers
import NavigationController from "../components/navigation/controller"
import FlashController from "../components/flash/controller"
import CookiesBarController from "../components/cookies_bar/controller"
import DocumentedIconController from "../components/icon/controller"

const application = Application.start()
application.register("navigation", NavigationController)
application.register("flash", FlashController)
application.register("cookies-bar", CookiesBarController)
application.register("documented-icon", DocumentedIconController)
